import "./UhfFooter.css";

import cx from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import { CSSTransition, SwitchTransition } from "react-transition-group";

import { getUhfFooter, getUhfFooterMode, UhfFooterMode } from "@gamedev-web/gamedev-uhf";

import { RawUhfContainer } from "../RawUhfContainer";

import type { RootState } from "../../../redux/reducers/rootReducer";
export const UhfFooter = () => {
  const mode: UhfFooterMode = useSelector(getUhfFooterMode);
  // Provides a way to opt-out of the UHF footer, however, the caller is
  // responsible for compliance and accessibility
  if (mode === UhfFooterMode.Off) {
    return null;
  }

  return <UhfFooterRender mode={mode} />;
};

type Props = Readonly<{
  mode: UhfFooterMode;
}>;

const UhfFooterRender = ({ mode }: Props) => {
  const footerHtml = useSelector((state: RootState) => getUhfFooter(state));

  return (
    <SwitchTransition mode={"out-in"}>
      <CSSTransition
        key={"light"}
        in={true}
        timeout={{ appear: 300, enter: 300, exit: 100 }}
        classNames="uhf-footer"
      >
        <RawUhfContainer
          htmlContent={footerHtml}
          className={cx(
            "uhf-footer",
            { ["uhf-dark"]: false },
            `uhf-footer-mode-${mode.toLowerCase()}`
          )}
        />
      </CSSTransition>
    </SwitchTransition>
  );
};
